import { render, staticRenderFns } from "./ParticipantWizardLinkModal.vue?vue&type=template&id=3b4c4e3f&scoped=true&"
import script from "./ParticipantWizardLinkModal.vue?vue&type=script&lang=js&"
export * from "./ParticipantWizardLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantWizardLinkModal.vue?vue&type=style&index=0&id=3b4c4e3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c4e3f",
  null
  
)

component.options.__file = "ParticipantWizardLinkModal.vue"
export default component.exports